import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/AddCircleOutline";

import ActionModal from "../../modals/action-modal";

const initialPhysicalDimensions = {
  depth: "",
  width: "",
  height: "",
};

const styles = {
  button: {
    minWidth: 80,
  },
};

const DimensionsField = ({ field, onSubmit, value, nextRow, onClose }) => {
  const [fields, setFields] = useState(value?.length ? value : [initialPhysicalDimensions]);

  const handleAddNew = () => {
    setFields((fields) => fields.concat(initialPhysicalDimensions));
  };

  const handleRemove = (selectedIndex) => {
    setFields((fields) => fields.filter((v, index) => selectedIndex !== index));
  };

  const updateField = (index, variables) => {
    setFields((fields) => [
      ...fields.slice(0, index),
      { ...fields[index], ...variables },
      ...fields.slice(index + 1),
    ]);
  };

  const handleSubmit = () => {
    onSubmit(fields);
    onClose();
    if (typeof nextRow === "function") {
      nextRow();
    }
  };

  return (
    <ActionModal
      open
      maxWidth={460}
      onClose={onClose}
      title={field.label}
      titleFontSize="1.5rem"
      disableTransition
    >
      <Grid container spacing={2} sx={{ pt: 1 }}>
        {fields.map((v, index) => (
          <Grid key={index} size={12}>
            <Box display="flex" alignItems="center">
              <Grid container spacing={1}>
                <Grid size={4}>
                  <TextField
                    variant="outlined"
                    name={`dimensions.${index}.width`}
                    label="Width (in)"
                    value={fields[index]["width"]}
                    onChange={(event) => updateField(index, { width: event.target.value })}
                    inputProps={{ inputMode: "decimal" }}
                  />
                </Grid>
                <Grid size={4}>
                  <TextField
                    variant="outlined"
                    name={`dimensions.${index}.depth`}
                    label="Depth (in)"
                    value={fields[index]["depth"]}
                    onChange={(event) => updateField(index, { depth: event.target.value })}
                    inputProps={{ inputMode: "decimal" }}
                  />
                </Grid>
                <Grid size={4}>
                  <TextField
                    variant="outlined"
                    name={`dimensions.${index}.height`}
                    label="Height (in)"
                    value={fields[index]["height"]}
                    onChange={(event) => updateField(index, { height: event.target.value })}
                    inputProps={{ inputMode: "decimal" }}
                  />
                </Grid>
              </Grid>
              {fields.length > 1 && (
                <Box p={1} mr={-1} clone>
                  <IconButton
                    aria-label="delete"
                    variant="outlined"
                    onClick={() => handleRemove(index)}
                  >
                    <DeleteIcon color="action" />
                  </IconButton>
                </Box>
              )}
            </Box>
          </Grid>
        ))}
        <Grid container justifyContent="center" size={12}>
          <Box display="flex" justifyContent="center">
            <IconButton onClick={handleAddNew}>
              <AddIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <Box mb={3} />
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button variant="outlined" color="primary" onClick={onClose} sx={styles.button}>
          Close
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} sx={styles.button}>
          Save
        </Button>
      </Box>
    </ActionModal>
  );
};

export default React.memo(DimensionsField);
